import RotateLeftRoundedIcon from "@mui/icons-material/RotateLeftRounded";
import { Box, Typography } from "@mui/material";

interface ILoadingWrapper {
  message?: string;
  animate?: boolean;
  icon?: JSX.Element;
  messageSx?: object;
}

export default function LoadingWrapper(props: ILoadingWrapper): JSX.Element {
  const { message, icon, animate, messageSx } = props;
  const animationCSS: object = {
    animation: "spin 1s ease-in-out infinite reverse",
  };
  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <Box sx={{ pr: 1 }}>
        {icon && <Box sx={animate !== false ? animationCSS : {}}>{icon}</Box>}
        {!icon && <RotateLeftRoundedIcon sx={animate !== false ? animationCSS : {}} />}
      </Box>
      {message && <Typography sx={{ ...(messageSx ?? {}) }}>{message}</Typography>}
    </Box>
  );
}
